import React from 'react';
import { useAuth } from '~/hooks/useAuth';
import styles from './Logo.module.css';

function Logo() {
  const { logout } = useAuth();

  const onClickLogo = () => {
    // Kliknięcie w logo = całkowite wylogowanie z czatu
    // (serwer + WebRTC + localStorage/sessionStorage + stan).
    logout();
  }

  return (
    <div className={styles.logoWrapper} onClick={onClickLogo}>
      <div className={styles.iconContainer}>
        <svg
          className={styles.bubbleIcon}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: 'scaleX(-1)' }}
        >
          <path
            d="M21 11.5C21 15.6421 17.4183 19 13 19C11.753 19 10.5756 18.7331 9.51322 18.2544L5 20L6.5 16.5C5.56303 15.1437 5 13.394 5 11.5C5 7.35786 8.58172 4 13 4C17.4183 4 21 7.35786 21 11.5Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="10" cy="11.5" r="1" fill="currentColor" />
          <circle cx="13" cy="11.5" r="1" fill="currentColor" />
          <circle cx="16" cy="11.5" r="1" fill="currentColor" />
        </svg>
      </div>

      <div className={styles.logoText}>
        <span>CZATERIA</span>
        <span className={styles.accent}>24</span>
      </div>
    </div>
  );
}

export default Logo;